'use client'

import React from 'react'

import { Box, HTMLChakraProps } from '@chakra-ui/react'

import { ChevronDownIcon } from '../Icon/ChevronDownIcon'
import {
  ColorScheme,
  cardFooterStyles,
  cardHeaderStyles,
  cardStyles,
  chevronStyles,
  collapsibleRowStyles,
  expandableInnerStyles,
  expandableWrapperStyles,
} from './Card.styles'

export type { ColorScheme }

export type CardProps = HTMLChakraProps<'div'> & {
  colorScheme?: ColorScheme
}

export const Card = ({
  colorScheme = 'dark',
  children,
  ...rest
}: CardProps) => (
  <Box {...cardStyles(colorScheme)} {...rest}>
    {children}
  </Box>
)

export type CardHeaderProps = HTMLChakraProps<'div'>

export const CardHeader = ({ children, ...rest }: CardHeaderProps) => (
  <Box {...cardHeaderStyles} {...rest}>
    {children}
  </Box>
)

export type CardFooterProps = HTMLChakraProps<'div'> & {
  colorScheme?: ColorScheme
}

export const CardFooter = ({
  colorScheme = 'dark',
  children,
  ...rest
}: CardFooterProps) => (
  <Box {...cardFooterStyles(colorScheme)} {...rest}>
    {children}
  </Box>
)

export type CardCollapsibleRowProps = Omit<
  HTMLChakraProps<'div'>,
  'onClick'
> & {
  isExpanded: boolean
  onToggle: () => void
  colorScheme?: ColorScheme
  children: React.ReactNode
}

export const CardCollapsibleRow = ({
  isExpanded,
  onToggle,
  colorScheme = 'dark',
  children,
  ...rest
}: CardCollapsibleRowProps) => (
  <Box {...collapsibleRowStyles} onClick={onToggle} {...rest}>
    {children}
    <Box {...chevronStyles(isExpanded, colorScheme)}>
      <ChevronDownIcon />
    </Box>
  </Box>
)

export type CardExpandableProps = {
  isExpanded: boolean
  children: React.ReactNode
}

export const CardExpandable = ({
  isExpanded,
  children,
}: CardExpandableProps) => (
  <Box aria-hidden={!isExpanded} {...expandableWrapperStyles(isExpanded)}>
    <Box {...expandableInnerStyles}>{children}</Box>
  </Box>
)
